import {
  STORE_STATUS_INITIALIZED,
  STORE_POLICY,
  STORE_FETCH_CONTRACT,
} from 'constants/store'
import {
  createGenericSlice,
  createReducers,
  ExtraReducers,
  GenericState,
} from 'stores/generics'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { Payload } from 'stores'
import { ContractData, ErrorStore } from '@types'

export type ContractState = ContractData[]

type State = GenericState<ContractState>

export const initialState: State = {
  data: [],
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchContracts = createAsyncThunk<
  ContractState,
  Promise<ContractData[]>,
  Payload
>(STORE_FETCH_CONTRACT, async (promise, { rejectWithValue, getState }) => {
  try {
    const response = await promise
    return [...response, ...getState().policy.contracts.data].reduce<
      ContractData[]
    >((acc, current: ContractData) => {
      const foundItemIndex = acc.findIndex(
        (item: ContractData) => item.type === current.type
      )
      if (foundItemIndex !== -1) {
        acc[foundItemIndex] = { ...acc[foundItemIndex], ...current }
        return acc
      } else {
        return acc.concat([current as never])
      }
    }, [])
  } catch (e: unknown) {
    const { code, message } = e as ErrorStore
    return rejectWithValue({ code, message })
  }
})

const extraReducers: ExtraReducers = createReducers<
  ContractState,
  ContractData[],
  Payload
>(fetchContracts, initialState.data)

const slice = createGenericSlice({
  name: STORE_POLICY,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = slice

const { clear, success, start } = actions

export { clear, start, success }

export default reducer
